module.exports = __webpack_public_path__ + "img/pb2.d7a9a41f.png";